
export default {
    STATIC_URL: "https://static.kaiba315.com.cn/"
}